import { render, staticRenderFns } from "./TaxReturnSidebar.vue?vue&type=template&id=59ebd2aa"
import script from "./TaxReturnSidebar.vue?vue&type=script&lang=js"
export * from "./TaxReturnSidebar.vue?vue&type=script&lang=js"
import style0 from "./TaxReturnSidebar.vue?vue&type=style&index=0&id=59ebd2aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports